<div *ngIf="show" class="tile tile--icon tile--alert tile--nsGrey8 tile--slim tile--noShadow formErrorSummary">
  <div class="tile__title">
    <p class="formErrorSummary__intro">
      <i class="icon icon--alert icon--nsRed"></i>
      <span id="error-message" [innerHtml]="textOrKey | translate"></span>
    </p>
  </div>
</div>
